import type { FinancialDailySessionKey, FinancialDailyListPatch } from '../types/utils'
import {
  FINANCIAL_DAILY_DEFAULTS_SESSION_KEY,
  FINANCIAL_DAILY_SESSION_KEY,
} from '../constants/sessionKeys'

export { FINANCIAL_DAILY_DEFAULTS_SESSION_KEY, FINANCIAL_DAILY_SESSION_KEY }

export function readFinancialDailySession(
  key: FinancialDailySessionKey,
): Record<string, unknown> | null {
  try {
    const raw = sessionStorage.getItem(key)
    if (!raw) return null
    const value = JSON.parse(raw) as unknown
    return value && typeof value === 'object' && !Array.isArray(value)
      ? (value as Record<string, unknown>)
      : null
  } catch {
    return null
  }
}

export function writeFinancialDailySession(
  key: FinancialDailySessionKey,
  data: Record<string, unknown>,
): void {
  sessionStorage.setItem(key, JSON.stringify(data))
}

export function clearFinancialDailySession(
  key: FinancialDailySessionKey,
): void {
  sessionStorage.removeItem(key)
}

function normalizeStringArray(value: unknown): string[] {
  if (!Array.isArray(value))
    return typeof value === 'string' && value ? [value] : []
  return value.map(String).filter(Boolean)
}

export function sessionFilterToFinancialDailyPatch(
  session: Record<string, unknown>,
): FinancialDailyListPatch {
  const patch: FinancialDailyListPatch = {}
  if (typeof session.page === 'number' && session.page > 0)
    patch.page = session.page
  if (typeof session.perPage === 'number' && session.perPage > 0)
    patch.perPage = session.perPage
  if (session.sortBy === 'asc' || session.sortBy === 'desc')
    patch.sortBy = session.sortBy
  if (typeof session.orderBy === 'string' && session.orderBy.trim())
    patch.orderBy = session.orderBy
  if (typeof session.fromDt === 'string') patch.fromDt = session.fromDt
  if (typeof session.toDt === 'string') patch.toDt = session.toDt
  patch.payment_source = normalizeStringArray(session.payment_source)
  return patch
}

export function buildFinancialDailySessionFromParams(p: {
  page: number
  perPage: number
  sortBy: string
  orderBy: string
  fromDt: string
  toDt: string
  payment_source: string[]
}): Record<string, unknown> {
  const out: Record<string, unknown> = {
    page: p.page,
    perPage: p.perPage,
    sortBy: p.sortBy,
    orderBy: p.orderBy,
  }
  if (p.fromDt) out.fromDt = p.fromDt
  if (p.toDt) out.toDt = p.toDt
  if (p.payment_source.length) out.payment_source = p.payment_source
  return out
}
